import React from 'react'

import classes from './PokemonType.module.scss';


function PokemonType(props) {
    return (
        <div className={`${classes[props.type]} ${classes.type}`}>
            {props.children}
        </div>
    )
}

PokemonType.propTypes = {

}

export default PokemonType

